import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {MatSelectModule} from '@angular/material/select';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { LoaderModule } from "src/app/shared/loader/loader.module";
import { SharedModule } from "src/app/shared/shared.module";
import { PrefixSuffixRoutingModule } from "./prefix-suffix-routing.module";
import { PrefixSuffixComponent } from "./prefix-suffix.component";

@NgModule({
    declarations: [
      PrefixSuffixComponent
    ],
    imports: [
      CommonModule,
      MatSelectModule,
      PrefixSuffixRoutingModule,
      ReactiveFormsModule,
      FormsModule,
      NgbModule,
      LoaderModule,
      SharedModule
    ]
  })
  export class PrefixSuffixModule { }